import $     from 'jquery'
import _find from 'lodash/find'

class MyToolboxController {
  constructor (Localization, ValidationRules, HelpersService, RegistrationHelper, RegistrationService, $scope, $state, $stateParams, $location, I18n, StoreTypes) {
    'ngInject'

    // Set injections
    this.appConfig = Localization.getLocalizedAppConfig()
    this.ValidationRules = ValidationRules
    this.HelpersService = HelpersService
    this.RegistrationHelper = RegistrationHelper
    this.RegistrationService = RegistrationService
    this.$scope = $scope
    this.$state = $state
    this.$stateParams = $stateParams
    this.$location = $location
    this.I18n = I18n
    this.type = Localization.getLocalizedAppConfig().type
    this.StoreTypes = StoreTypes

    this.profile = {}
    this.vehicle = {}

    this.checkStep1Params()
    this.checkStep2Params()
    this.checkStep3Params()
  }

  /**
   * Verify state params relative to step 1 - My Profile : civility, first name, last name, email, password and mobile phone
   * If one of these is incorr, the user is redirected to step 1
   */
  checkStep1Params () {
    const civilityChecked = this.RegistrationHelper.checkCivility(this.$stateParams.civility)
    const firstNameChecked = this.RegistrationHelper.checkMaxLength(this.$stateParams.firstName, this.ValidationRules.firstName.maxlength)
    const lastNameChecked = this.RegistrationHelper.checkMaxLength(this.$stateParams.lastName, this.ValidationRules.lastName.maxlength)
    const emailChecked = this.RegistrationHelper.checkEmail(this.$stateParams.email)
    const passwordChecked = this.RegistrationHelper.checkPassword(this.$stateParams.password)
    if (civilityChecked && firstNameChecked && lastNameChecked && emailChecked && passwordChecked) {
      this.profile.civility = civilityChecked ? this.$stateParams.civility : undefined
      this.profile.firstName = firstNameChecked ? this.$stateParams.firstName : undefined
      this.profile.lastName = lastNameChecked ? this.$stateParams.lastName : undefined
      this.profile.email = emailChecked ? this.$stateParams.email : undefined
      this.profile.password = passwordChecked ? this.$stateParams.password : undefined
    } else {
      return this.$state.go('registration.myProfile', { profile: undefined })
    }
  }

  /**
   * Verify state params relative to step 2 - My Rlink
   *
   * @return {Promise} go back to step 2 if the model is not in the configuration
   */
  checkStep2Params () {
    if (!this.$stateParams.model || !this.RegistrationHelper.checkModel(this.$stateParams.model, this.appConfig.rlinkModels)) {
      return this.$state.go('registration.myRlink', { model: undefined })
    } else {
      this.toolboxInfos = _find(this.appConfig.rlinkModels, ['id', this.$stateParams.model]).toolbox
    }
  }

  /**
   * Verify state params relative to step 3 - My Toolbox : Friendly Name, VIN and MUID
   * If one of these is correct, the form is filled with it
   */
  checkStep3Params () {
    const friendlyNameChecked = this.RegistrationHelper.checkMaxLength(this.$stateParams.friendlyName, this.ValidationRules.friendlyName.maxlength)
    const vinChecked = this.RegistrationHelper.checkVin(this.$stateParams.vin)
    this.vehicle.friendlyName = friendlyNameChecked ? this.$stateParams.friendlyName : undefined
    this.vehicle.vin = vinChecked ? this.$stateParams.vin : undefined
  }

  backToStep1 () {
    return this.$state.go('registration.myProfile',
      {
        civility: this.$stateParams.civility,
        firstName: this.$stateParams.firstName,
        lastName: this.$stateParams.lastName,
        email: this.$stateParams.email,
        model: this.$stateParams.model,
        friendlyName: this.vehicle.friendlyName,
        vin: this.vehicle.vin
      })
  }

  backToStep2 () {
    return this.$state.go('registration.myRlink',
      {
        civility: this.$stateParams.civility,
        firstName: this.$stateParams.firstName,
        lastName: this.$stateParams.lastName,
        email: this.$stateParams.email,
        password: this.$stateParams.password,
        model: this.$stateParams.model,
        friendlyName: this.vehicle.friendlyName,
        vin: this.vehicle.vin
      })
  }

  completeProfile () {
    this.profile.friendlyName = this.vehicle.friendlyName
    this.profile.vin = this.vehicle.vin
  }

  submit () {
    if (this.$scope.toolboxForm.$valid) {
      this.completeProfile()
      this.isProcessing = true
      return this.RegistrationService.register(this.profile)
      .then((success) => {
        this.success = success
        this.isProcessing = false
        return this.$state.go('registrationConfirmation', { email: this.profile.email })
      }, (err) => {
        this.error = {
          message: 'error.' + err.data.meta.code,
          cause: err
        }
        this.$location.hash('errorMessage')
        this.isProcessing = false
      })
    } else {
      // Hack for mobile submit button
      this.$scope.toolboxForm.$submitted = true
      // Scroll to first invalid element
      $('[name="' + this.$scope.toolboxForm.$name + '"]').find('.ng-invalid:visible:first').focus()
    }
  }

  openTooltip ($event) {
    this.HelpersService.openTooltip($event.currentTarget)
  }

  closeTooltip () {
    this.HelpersService.closeTooltip()
  }

  get isIframe () {
    return (this.type === this.StoreTypes.HELIOS ||
      this.type === this.StoreTypes.MYRENAULT ||
      this.type === this.StoreTypes.RSITE ||
      this.type === this.StoreTypes.ONE)
  }

}
export default MyToolboxController



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-toolbox/my-toolbox.controller.js